export const COLORS_MAP = {
  todo: '#FFDE69',
  done: '#BAD4BD',
  doing: '#74EC81'
}
